import React from 'react';
import {Button} from '~/components/Button';
import {useConfirm} from '~/components/Dialogs';
import {IntentText} from '~/components/Form';
// import {Popover} from '~/components/Popover';
import {Intent} from '~/lib/intent';
import {AttributesMenu} from '~/modules/Bidders/components/PreTargetingRules/AttributesMenu';
import {AttributeValue} from '~/modules/Bidders/components/PreTargetingRules/AttributeValue';
import {OperationSelect} from '~/modules/Bidders/components/PreTargetingRules/OperationSelect';
import {IRule} from '~/modules/Bidders/models/Rule';
import {Schema} from '~/modules/Bidders/models/Schema';
import style from './PreTargetingRules.module.scss';

interface IPreTargetingConfigRule {
    rule: IRule;
    schema: Schema;
    variables: string[];
    onChange: (rule: IRule) => void;
    onDelete: () => void;
}

export const PreTargetingRule = ({rule, schema, variables, onChange, onDelete}: IPreTargetingConfigRule) => {
    const confirm = useConfirm();
    const attribute = schema.attribute(rule.attr);
    return <div className={style.rule}>
        {!attribute
            ? <IntentText className={style.ruleError} intent={Intent.DANGER}>No info by attribute: {rule.attr}</IntentText>
            : <>
                <div className={style.childrenInner}>
                    <div className={style.attribute}>{attribute.label}</div>
                    <div className={style.operation}>
                        <OperationSelect operation={rule.op} attribute={attribute} onChange={op => onChange(schema.castRule(rule, op))}/>
                    </div>
                    <div className={style.value}>
                        {rule.value != null && <AttributeValue rule={rule} attribute={attribute} variables={variables}
                            onChange={value => onChange({...rule, value})}/>}
                    </div>
                    <div className={style.actions}>
                        <Button className={`${rule.variable ? 'primary' : ''} small`} type='button' leftIcon={<i className='fa fa-cubes'/>}
                            onClick={() => onChange({
                                ...rule,
                                variable: !rule.variable,
                                value: !rule.variable ? '' : schema.defaultValue(attribute)
                            })} intent={rule.variable && Intent.SUCCESS}/>
                        <Button leftIcon={<i className='fa fa-trash'/>}
                            onClick={() => confirm(`Remove '${attribute.label}' rule?`, {
                                onOk: () => onDelete(),
                                intent: Intent.WARNING,
                                icon: <i className='fa fa-warning'/>
                            })}/>
                        <AttributesMenu schema={schema} onSelect={attributeInfo =>
                            onChange({
                                ...rule,
                                children: schema.concatRules(rule.children || [], Schema.buildRule(attributeInfo))
                            })}/>
                    </div>
                </div>
                {(rule.children && rule.children.length > 0) && <div className={style.children}>
                    {rule.children.map((child, index) => <PreTargetingRule
                        key={index}
                        rule={child}
                        variables={variables}
                        schema={schema}
                        onChange={(changedRule) => {
                            rule.children[index] = changedRule;
                            onChange({...rule});
                        }}
                        onDelete={() => {
                            delete rule.children[index];
                            onChange({
                                ...rule,
                                children: rule.children.filter(filterRule => !!filterRule)
                            });
                        }}
                    />)}
                </div>}
            </>}
    </div>;
};
